import Login from '../Login/Login'

const Home = () => {

    return (
        <>
           {/* <Navbar/> */}
          
           <Login/>
           
        </>
    );
};

export default Home;